// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1EE5A","buttons":"RemoveExpirationActionButtons_buttons__VfFr6"};